import React from 'react';

const Deck = () => {
  return (
    <div className="deck d-flex flex-column justify-content-center align-items-center">
      <h1>Ready to start❓</h1>
      <h1>New features are coming soon❗</h1>
    </div>
  );
};

export default Deck;
